import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { HomePage } from "@/pages/Home";
import { Toaster } from "sonner";

const LoginPage = lazy(() => import("@/pages/Login").then((module) => ({ default: module.LoginPage })));
const StudentPortal = lazy(() => import("@/pages/StudentPortal").then((module) => ({ default: module.StudentPortal })));
const Unauthorized = lazy(() => import("@/pages/Unauthorized").then((module) => ({ default: module.Unauthorized })));
const ContactPage = lazy(() => import("@/pages/InfoPages").then((module) => ({ default: module.ContactPage })));
const PrivacyPage = lazy(() => import("@/pages/InfoPages").then((module) => ({ default: module.PrivacyPage })));
const TermsPage = lazy(() => import("@/pages/InfoPages").then((module) => ({ default: module.TermsPage })));

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Toaster richColors position="top-center" />
          <BrowserRouter>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route
                  path="/portal"
                  element={
                    <ProtectedRoute>
                      <StudentPortal />
                    </ProtectedRoute>
                  }
                />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
